module.exports = __webpack_public_path__ + "img/shopImage.09741856.png";